var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog-loader', _vm._g(_vm._b({
    attrs: {
      "width": "500",
      "loading": !_vm.didLoad,
      "value": _vm.value
    }
  }, 'v-dialog-loader', _vm.$attrs, false), _vm.$listeners), [_c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Pack of " + _vm._s(_vm.n) + " cards")]), _c('v-card-subtitle', [_vm._v("These credits can be used for "), _c('b', [_vm._v("personal cards")]), _vm._v(", "), _c('b', [_vm._v("group cards")]), _vm._v(", or "), _c('b', [_vm._v("invitations")]), _vm._v(". Premium effects not included.")]), _vm.global.profile && _vm.global.profile.org ? _c('v-card-subtitle', {
    staticClass: "warning--text font-weight-bold"
  }, [_vm._v("Card credits will be applied to your organization")]) : _vm._e(), _c('v-divider'), _c('payment', {
    staticClass: "pa-6",
    attrs: {
      "metadata": _vm.paymentMetadata
    },
    on: {
      "complete": function ($event) {
        _vm.$emit('purchase');

        _vm.$emit('input', false);
      },
      "loaded": function ($event) {
        _vm.didLoad = true;
      }
    }
  }), _c('v-divider'), _c('v-card-text', {
    staticClass: "pa-4 caption font-italic"
  }, [_vm._v(" Card credits will be saved to your account when purchased and automatically applied at checkout. You can always see the number of pre-paid / free card credits available in your account. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }